import { darken, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '3fr 1fr',
    color: 'gray',
    alignItems: 'center',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor:
      theme.palette.type === 'dark'
        ? darken(theme.palette.background.default, 0.3)
        : '#f7f7f7',
    borderRadius: 12,
    paddingLeft: 20,
    paddingRight: 7,
    paddingTop: 8,
    paddingBottom: 8
  }
}))
export default useStyles
